export default {
      id: "carousel-usage",
      viewBox: "0 0 512 306",
      url: __webpack_public_path__ + "img/svg-sprite.svg#carousel",
      toString: function () {
        return this.url;
      }
    }